import React from 'react';
import ReactDOM from 'react-dom';
import { subscribe } from 'reffects-store';
import { dispatch } from 'reffects';
import LoginForm from './LoginForm';
import LoginLayout from '../../components/LoginLayout/LoginLayout';
import ForgotPassword from './ForgotPassword/ForgotPassword';
import registerLoginEvents from './events';
import registerForgotPasswordEvents from './ForgotPassword/events';

export default function Login({
  isForgotPasswordVisible,
  targetPath,
  onShowForgotPasswordForm,
  onShowLoginForm,
}) {
  return (
    <LoginLayout>
      {isForgotPasswordVisible ? (
        <ForgotPassword onShowLoginForm={onShowLoginForm} />
      ) : (
        <LoginForm
          onShowForgotPasswordForm={onShowForgotPasswordForm}
          targetPath={targetPath}
        />
      )}
    </LoginLayout>
  );
}

const SubscribedLogin = subscribe(
  Login,
  function mapStateToProps(state) {
    return {
      isForgotPasswordVisible: isForgotPasswordVisibleSelector(state),
      targetPath: targetPathSelector(state),
    };
  },
  {
    onShowForgotPasswordForm() {
      dispatch('SHOW_FORGOT_PASSWORD_FORM');
    },
    onShowLoginForm() {
      dispatch('SHOW_LOGIN_FORM');
    },
  }
);

(function LoginPage() {
  const rootElement = document.getElementById('login');

  if (!rootElement) {
    return;
  }

  registerLoginEvents();
  registerForgotPasswordEvents();

  dispatch('RETRIEVE_TARGET_PATH');

  ReactDOM.render(<SubscribedLogin />, rootElement);
})();

function isForgotPasswordVisibleSelector(state) {
  return state.isForgotPasswordVisible;
}

function targetPathSelector(state) {
  return state.targetPath;
}
